import { SubscriptionPlan, Location } from ".";
export class LocationSubscription {
  public locationId: number;
  public subscriptionPlanId: number;
  public active: boolean;
  public startDate: Date;
  public location: Location;
  public subscriptionPlan: SubscriptionPlan;
}
